import { useEffect } from 'react';

const OAuthSuccess = () => {
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const userId = params.get('userId');
  const role = params.get('role'); // ✅ new

  if (token && userId && role) {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('role', role); // ✅ store role

    window.dispatchEvent(new Event('storage'));
    window.location.replace('/');
  } else {
    window.location.replace('/entry');
  }
}, []);


  return <p>Processing authentication...</p>;
};

export default OAuthSuccess;